import { render, staticRenderFns } from "./PageWechatEmpty.vue?vue&type=template&id=89ab323e&scoped=true"
import script from "./PageWechatEmpty.vue?vue&type=script&lang=js"
export * from "./PageWechatEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ab323e",
  null
  
)

export default component.exports